import React from 'react';
import formatLongDate from '../../shared/utils/formatLongDate';

const FREQ_LABELS = {
  one_time: 'One-time',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  semi_annually: 'Semi-Annually',
  annually: 'Annually',
};

function Row({ label, value, link = false }) {
  const none = value === null || value === undefined || value === '';
  return (
    <div className="pd-kv">
      <span className="pd-kv-label">{label}</span>
      <span className={`pd-kv-val ${none ? 'pd-kv-val-none' : ''} ${!none && link ? 'pd-kv-val-link' : ''}`}>
        {none ? '—' : value}
      </span>
    </div>
  );
}

export default function PledgeDetailsSidebar({ pledge }) {
  return (
    <div className="pd-card">
      <div className="pd-card-head">
        <h2 className="pd-card-title">Pledge details</h2>
      </div>
      <div className="pd-card-body">
        <Row label="Fund" value={pledge.fund?.name} link />
        <Row label="Campaign" value={pledge.giving_campaign?.name} link />
        <Row label="Appeal" value={pledge.appeal?.name} />
        <Row label="Solicitor" value={pledge.solicitor?.name} />
        <Row label="Frequency" value={FREQ_LABELS[pledge.installment_frequency]} />
        <Row label="Pledge date" value={formatLongDate(pledge.pledge_date)} />
        <Row label="Fulfill by" value={formatLongDate(pledge.expected_fulfillment_date)} />
        <Row
          label="Payment card"
          value={pledge.card && `${pledge.card.brand} •••• ${pledge.card.last4} (exp ${pledge.card.exp_month}/${pledge.card.exp_year})`}
        />
        {pledge.card && <Row label="Processing fees" value={pledge.cover_processing ? 'Donor covers' : 'Organization absorbs'} />}
        {pledge.terms_and_conditions && <Row label="Terms" value={pledge.terms_and_conditions} />}
      </div>
    </div>
  );
}
